import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function respondOrganizationInvitation(id, action) {
  if (!id || !["accept", "reject"].includes(action)) {
    return {
      success: false,
      message: "처리할 조직 초대 정보가 올바르지 않습니다.",
      data: null,
    };
  }

  try {
    const response = await authFetch(
      `${BACKEND_URL}/organization/invitations/${id}/${action}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const data = await response.json().catch(() => ({}));
    return {
      success: response.ok && data?.success === true,
      message: data?.message ?? "",
      data: data?.data ?? null,
    };
  } catch (error) {
    console.error("[respondOrganizationInvitation] failed:", error);
    return {
      success: false,
      message: "조직 초대 처리 중 오류가 발생했습니다.",
      data: null,
    };
  }
}
